import React from 'react'
import { Link } from "react-router-dom"
import { Redirect, withRouter } from 'react-router-dom'
import { Tabs, Descriptions, Collapse, Table, Typography, Spin } from 'antd'
import { reqFeatureInfo } from '../../api'
import './feature.css'

const { TabPane } = Tabs
const { Panel } = Collapse
const { Paragraph } = Typography

class Feature extends React.Component {
    state = {
        genomics_info: '',
        relationship: '',
        sequence_info: '',
        blast_vs_arabidopsis_info: '',
        blast_vs_nr_info: '',
        blast_vs_swissprot_info: '',
        blast_vs_uniprot_trembl_info: '',
        go_info: '',
        ipr_info: '',
        kegg2pathways_info: '',
        kegg2orthologs_info: '',
        spinning: true,
    }

    async componentDidMount() {
        const pathSnippets = this.props.location.pathname.split('/').filter(i => i)
        this.props.setPathSnippetsState(pathSnippets)
        
        const feature_id = this.props.match.params.feature_id
        const result = await reqFeatureInfo(feature_id)
    
        if (result.code === 0) {
            this.setState(
                {...result.data}
            )
            this.setState({
                spinning: false
            })
        } else if(result.code == 404) {
            this.props.history.push('/feature/notExists')
        }   
    }

    render() {
        const { genomics_info, relationship, sequence_info, blast_vs_arabidopsis_info, blast_vs_nr_info, blast_vs_swissprot_info, blast_vs_uniprot_trembl_info, go_info, ipr_info, kegg2pathways_info, kegg2orthologs_info, spinning } = this.state
        
        const blast_info_table_columns = [
            {
                title: 'query',
                dataIndex: 'query',
                key: 'query'
            },
            {
                title: 'query_length',
                dataIndex: 'query_length',
                key: 'query_length'
            },
            {
                title: 'match',
                dataIndex: 'match',
                key: 'match'
            },
            {
                title: 'description',
                dataIndex: 'description',
                key: 'description'
            },
            {
                title: 'organism',
                dataIndex: 'organism',
                key: 'organism'
            },
            {
                title: 'exp',
                dataIndex: 'exp',
                key: 'exp'
            },
            {
                title: 'score',
                dataIndex: 'score',
                key: 'score'
            },
            {
                title: 'pid',
                dataIndex: 'pid',
                key: 'pid'
            },
            {
                title: 'align_length',
                dataIndex: 'align_length',
                key: 'align_length'
            },
            {
                title: 'query_start',
                dataIndex: 'query_start',
                key: 'query_start'
            },
            {
                title: 'query_stop',
                dataIndex: 'query_stop',
                key: 'query_stop'
            },
            {
                title: 'match_start',
                dataIndex: 'match_start',
                key: 'match_start'
            },
            {
                title: 'match_stop',
                dataIndex: 'match_stop',
                key: 'match_stop'
            }
        ]

        const other_table_columns = [
            {
                title: 'query',
                dataIndex: 'query',
                key: 'query'
            },
            {
                title: 'match',
                dataIndex: 'match',
                key: 'match'
            },
            {
                title: 'description',
                dataIndex: 'description',
                key: 'description'
            }
        ]

        /**  注释信息表格  **/
        // 每个列表添加一个key
        if (blast_vs_arabidopsis_info) {
            for (let v of blast_vs_arabidopsis_info) {
                v['key'] = v['id']
            }
        }
        if (blast_vs_nr_info) {
            for (let v of blast_vs_nr_info) {
                v['key'] = v['id']
            }
        }
        if (blast_vs_swissprot_info) {
            for (let v of blast_vs_swissprot_info) {
                v['key'] = v['id']
            }
        }
        if (blast_vs_uniprot_trembl_info) {
            for (let v of blast_vs_uniprot_trembl_info) {
                v['key'] = v['id']
            }
        }
        if (go_info) {
            for (let v of go_info) {
                v['key'] = v['id']
            }
        }
        if (ipr_info) {
            for (let v of ipr_info) {
                v['key'] = v['id']
            }
        }
        if (kegg2pathways_info) {
            for (let v of kegg2pathways_info) {
                v['key'] = v['id']
            }
        }
        if (kegg2orthologs_info) {
            for (let v of kegg2orthologs_info) {
                v['key'] = v['id']
            }
        }
        const blast_vs_arabidopsi_info_table = <Table dataSource={blast_vs_arabidopsis_info} columns={blast_info_table_columns} pagination={false} />
        const blast_vs_nr_info_table = <Table dataSource={blast_vs_nr_info} columns={blast_info_table_columns} pagination={false} />
        const blast_vs_swissprot_info_table = <Table dataSource={blast_vs_swissprot_info} columns={blast_info_table_columns} pagination={false} />
        const blast_vs_uniprot_trembl_info_table = <Table dataSource={blast_vs_uniprot_trembl_info} columns={blast_info_table_columns} pagination={false} />
        const go_info_table = <Table dataSource={go_info} columns={other_table_columns} pagination={false} />
        const ipr_info_table = <Table dataSource={ipr_info} columns={other_table_columns} pagination={false} />
        const kegg2pathways_info_table = <Table dataSource={kegg2pathways_info} columns={other_table_columns} pagination={false} />
        const kegg2orthologs_info_table = <Table dataSource={kegg2orthologs_info} columns={other_table_columns} pagination={false} />

        // relationship
        let relationship_items = ''
        if (genomics_info.feature_type == 'gene') {
            relationship_items = relationship.map((i) => 
                <Paragraph key={i['feature_id']}>
                    <span>The mRNA <Link to={"/feature/" + i['feature_id']}>{i['feature_id']}</Link> is part of </span><b><i>{genomics_info.feature_id}</i></b>. &nbsp;&nbsp;
                    <span>The polypeptide <Link to={"/feature/" + i['protein_id']}>{i['protein_id']}</Link> is derives from </span><Link to={"/feature/" + i['feature_id']}>{i['feature_id']}</Link>.
                </Paragraph>
            )
        } else if (genomics_info.feature_type == 'mRNA') {
            relationship_items = <div>
                    <Paragraph><span>The mRNA <b><i>{genomics_info.feature_id}</i></b> is part of </span><Link to={"/feature/" + genomics_info.parent}>{genomics_info.parent}</Link>.</Paragraph>
                    <Paragraph><span>The polypeptide <Link to={"/feature/" + genomics_info.protein_id}>{genomics_info.protein_id}</Link> is derives from </span><b><i>{genomics_info.feature_id}</i></b>.</Paragraph>
                </div>
        } else if (genomics_info.feature_type == 'polypeptide') {
            relationship_items = relationship.map((i) => 
                <Paragraph key={i['feature_id']}>
                    <span>The polypeptide <b><i>{genomics_info.feature_id}</i></b> is derives from </span><Link to={"/feature/" + genomics_info.derives_from}>{genomics_info.derives_from}</Link>. &nbsp;&nbsp;
                    <span>The mRNA <Link to={"/feature/" + i['feature_id']}>{i['feature_id']}</Link> is part of </span><Link to={"/feature/" + i['parent']}>{i['parent']}</Link>.
                </Paragraph>
            )
        }

        return(
            <React.Fragment>
                <Spin spinning={spinning}>
                <Descriptions column={2} bordered className="feature_genomics_info">
                    <Descriptions.Item label="Resource Type">{genomics_info.feature_type}</Descriptions.Item>
                    <Descriptions.Item label="Name">{genomics_info.name}</Descriptions.Item>
                    <Descriptions.Item label="Identifier">{genomics_info.feature_id}</Descriptions.Item>
                    <Descriptions.Item label="Location">{genomics_info.seqid}:{genomics_info.feature_start}-{genomics_info.feature_end}</Descriptions.Item>
                    <Descriptions.Item label="Organism">{genomics_info.organism__abbreviation}</Descriptions.Item>
                </Descriptions>
                <Tabs tabPosition='left' type="card" className="feature_extra_info">
                    <TabPane tab="Sequence" key="sequence">
                        <Descriptions column={1} bordered>
                            <Descriptions.Item label="Length">{ String(sequence_info.seq).length }</Descriptions.Item>
                            <Descriptions.Item label="Sequence">
                                <Paragraph className="sequence_info" ellipsis={{rows: 20, expandable: true}}>
                                    {sequence_info.seq}
                                </Paragraph>
                            </Descriptions.Item>
                        </Descriptions>
                    </TabPane>
                    <TabPane tab="Annotation" key="annotation">
                        <Collapse defaultActiveKey={['blast_vs_arabidopsi']}>
                            <Panel header="Blast vs arabidopsis" key="blast_vs_arabidopsi">
                                {blast_vs_arabidopsi_info_table}
                            </Panel>
                            <Panel header="Blast vs nr" key="blast_vs_nr">
                                {blast_vs_nr_info_table}
                            </Panel>
                            <Panel header="Blast vs swissprot" key="blast_vs_swissprot">
                                {blast_vs_swissprot_info_table}
                            </Panel>
                            <Panel header="Blast vs uniprot_trembl" key="blast_vs_uniprot_trembl">
                                {blast_vs_uniprot_trembl_info_table}
                            </Panel>
                            <Panel header="GO" key="go">
                                {go_info_table}
                            </Panel>
                            <Panel header="IPR" key="ipr">
                                {ipr_info_table}
                            </Panel>
                            <Panel header="Kegg2pathways" key="kegg2pathways">
                                {kegg2pathways_info_table}
                            </Panel>
                            <Panel header="Kegg2orthologs" key="kegg2orthologs">
                                {kegg2orthologs_info_table}
                            </Panel>
                        </Collapse>
                    </TabPane>
                    <TabPane tab="Relationship" key="relationshhip">
                        <Descriptions column={1} bordered>
                            <Descriptions.Item label="Relationship">
                                { relationship_items }
                            </Descriptions.Item>
                        </Descriptions>
                    </TabPane>
                </Tabs>
                </Spin>
            </React.Fragment>
        )
    }
}

export default withRouter(Feature)